module.exports = __webpack_public_path__ + "img/127.90f9352c.jpg";